import {Component} from 'react';
import Boulier from './boulier.js';
import PhoneBlock from './phoneblock.js';
import imageyes from './img/essence-yes.png';
import imageno from './img/essence-no.png';
import logo from './img/logo-bleu.png';


class ResultScreen extends Component {

	render (){

		const startstyle = {
			background:'#fff',
			width:'100%',
			minHeight:'400px',
			borderRadius:'12px',
			boxShadow:'1px 1px 10px #ccc',
		}

		const buttonStyle = {
			color:'#000',
			backgroundColor : '#db6b40',
			borderRadius:'25px',
			border:'none',
			width:'200px',
			height:'50px',
			fontSize:'14px',
			fontWeight:'bold',
		}
		if(this.props.positif === true) {

			if(this.props.couple ){
				return (

					<div className="start-screen" style={startstyle} >
						<Boulier/>
						<div className="container" style={{position: 'relative' , display:'flex' , color : '#000' }} >
							<div className="desktop-only" style={{width:'50%'}}>
								<img src={imageyes} style={{ marginTop:'40px' }} />
								<img src={logo} style={{display:'block', position:'absolute' , left:'10px', bottom:'-26px'}}/>
							</div>
							<div className="text-content" style={{width:'calc( 50% - 50px)', textAlign:'left'}}>
								<h2><span style={{color:'#f6a00b' }} >Félicitations!</span></h2>
								<img className="mobile-only" src={imageyes}  />
								

								<p> Selon les informations saisies, vous devriez percevoir</p> 
								<p className="resultat-montant"><strong>{this.props.montant} €</strong> d’indemnité carburant.</p>
								
								<PhoneBlock />
								{ (this.props.unionLibre)?
								  <>
									<p>Les résultats sont donnés à titre indicatif. Seul le dépôt de votre demande permettra de connaître de façon certaine vos droits.</p>
									<p>Si vous souhaitez estimer les droits de votre conjoint(e) à l'indemnité carburant, effectuez une nouvelle simulation en renseignant son propre Revenu Fiscal de Référence.</p>
								  </>
								  :<>
								  	<p>Les résultats sont donnés à titre indicatif. Seul le dépôt de votre demande permettra de connaître de façon certaine vos droits.</p>
								  	<p>Attention, vous devez utiliser une voiture distincte pour bénéficier chacun de 100 €. Un même véhicule ne peut faire l’objet que d’un seul versement.</p>
								   </>
								}

								<div className="btn-container">
									<button className="restart-btn-end" onClick={(e)=>{this.props.restart()}} >Recommencer</button>
								</div>
								<br/>
								
							</div>
							
							
							<div className="mobile-only" style={{width:'100%' ,display:'block', position:'absolute' , left:'0', bottom:'20px'}} >
								<img src={logo} className="mobile-only" />
							</div>
						</div>
						
					</div>
				);
			}
			else {
				return (

					<div className="start-screen" style={startstyle} >
						<Boulier/>
						<div className="container" style={{position: 'relative' , display:'flex' , color : '#000' }} >
							<div className="desktop-only" style={{width:'50%'}}>
								<img src={imageyes} style={{ marginTop:'40px' }} />
								<img src={logo} style={{display:'block', position:'absolute' , left:'10px', bottom:'10px'}}/>
							</div>
							<div className="text-content" style={{width:'calc( 50% - 50px)', textAlign:'left'}}>
								<h2><span style={{color:'#f6a00b' }} >Félicitations!</span></h2>
								<img className="mobile-only" src={imageyes}  />

								<p>Selon les informations saisies, vous devriez percevoir</p> 
								<p className="resultat-montant"><strong>100 €</strong> d’indemnité carburant.</p>
								<PhoneBlock/> 
								<p>Les résultats sont donnés à titre indicatif. Seul le dépôt de votre demande permettra de connaître de façon certaine vos droits</p>
								<br/>
								<div className="btn-container">
									<button className="restart-btn-end" onClick={(e)=>{this.props.restart()}} >Recommencer</button>
								</div>
							</div>

							<div className="mobile-only" style={{width:'100%' ,display:'block', position:'absolute' , left:'0', bottom:'20px'}} >
								<img src={logo} className="mobile-only" />
							</div>
						</div>
						
					</div>
				);
			}
			
		}else {
			return (

				


				<div className="start-screen" style={startstyle} >
					<Boulier/>
					<div className="container" style={{position: 'relative' , display:'flex' , color : '#000' }} >
						<div className="desktop-only" style={{width:'50%'}}>
							<img src={imageno} style={{ marginTop:'40px' }} />
							<img src={logo} style={{display:'block', position:'absolute' , left:'10px', bottom:'10px'}}/>
						</div>
						<div className="text-content" style={{width:'calc( 50% - 50px)', textAlign:'left'}}>
							
							<img className="mobile-only" src={imageno}  />
							
							<p> Selon les informations fournies, vous ne semblez pas être éligible au versement de l’indemnité carburant. </p>
							<PhoneBlock />
							<p>Les résultats sont donnés à titre indicatif. Seul le dépôt de votre demande permettra de connaître de façon certaine vos droits.
							</p>
							<div className="btn-container">
								<button className="restart-btn-end" onClick={(e)=>{this.props.restart()}} >Recommencer</button>
							</div>
							<br/>
							
						</div>
						
						<div className="mobile-only" style={{width:'100%' , position:'absolute' , left:'0', bottom:'20px'}} >
							<img src={logo}  />
						</div>
					</div>
					
				</div>
			);

		}
	}
}
export default ResultScreen;